const SET_FILTER = 'data/SET_FILTER' as const;
const SET_INITIAL = 'data/SET_INITIAL' as const;
const SET_SONGS = 'data/SET_SONGS' as const;
const APPEND_SONGS = 'data/APPEND_SONGS' as const;
const INIT_SONGS = 'data/SET_INIT_SONGS' as const;
const SET_LENGTH = 'data/SET_LENGTH' as const;

type setTypeAction = {
    type: typeof SET_FILTER;
    payload: string;
};
type setDataAction = {
    type: typeof SET_SONGS;
    payload: Array<SongProps>;
};
type appendSongsAction = {
    type: typeof APPEND_SONGS;
    payload: Array<SongProps>;
};
type setInitialAction = {
    type: typeof SET_INITIAL;
    payload: boolean;
}
type initSongsAction = {
    type: typeof INIT_SONGS;
    payload: null;
}
type setLengthAction = {
    type: typeof SET_LENGTH;
    payload: number;
}

type ActionType = |
    setTypeAction |
    setDataAction |
    appendSongsAction |
    setInitialAction |
    initSongsAction |
    setLengthAction ;

export const setFilter = (type: string) => ({type : SET_FILTER, payload: type});
export const setSongsData = (songs: Array<SongProps>) => ({type: SET_SONGS, payload: songs});
export const appendSongsData = (songs: Array<SongProps>) => ({type: APPEND_SONGS, payload: songs});
export const setInitial = () => ({type: SET_INITIAL, payload: false});
export const initSongs = () => ({type: INIT_SONGS})
export const setLength = (length: number) => ({type: SET_LENGTH, payload: length})


interface SongProps {
    artist: string,
    title: string,
    folder: string,
    // 새로운 추적 필드들 (옵셔널 - 기존 데이터 호환성)
    id?: string,              // 구글 드라이브 파일 ID
    duration?: number,        // 재생 시간
    created_at?: string,      // 생성 날짜
    file_hash?: string,       // MD5 해시 (중복 체크용)
    mail_id?: string,         // 원본 메일 ID
    mail_date?: string,       // 메일 수신 날짜
    original_filename?: string, // 원본 파일명
}

interface InitialStateType {
    filter: string,
    songs: Array<SongProps>,
    initial: boolean,
    searchLength: number,
};

const initialState: InitialStateType = {
    filter: 'artist',
    songs: [],
    initial: true,
    searchLength: 0,
};

export default function data(state: InitialStateType = initialState, action: ActionType) {
    switch(action.type) {
        case SET_FILTER:
            return {
                ...state,
                filter: action.payload,
            };
        case SET_SONGS:
            return {
                ...state,
                songs: action.payload,
            };
        case APPEND_SONGS:
            return {
                ...state,
                songs: [...state.songs, ...action.payload],
            };
        case SET_INITIAL:
            return {
                ...state,
                initial: action.payload,
            }
        case INIT_SONGS:
            return initialState
        case SET_LENGTH:
            return {
                ...state,
                searchLength: action.payload,
            }
        default:
            return state;
    }
};